import { render, staticRenderFns } from "./VideoTaskPlayer.vue?vue&type=template&id=6fef880d&scoped=true&"
import script from "./VideoTaskPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoTaskPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoTaskPlayer.vue?vue&type=style&index=0&id=6fef880d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef880d",
  null
  
)

export default component.exports